import type { DataDimensionValue } from "./dimension.data.value";
import { DataDimensionValueType } from "./dimension.data.value";
import type { DataDimensionValueJsonConfig } from "./dimension.data.value.json";
import { DataDimensionValueJson } from "./dimension.data.value.json";
import type { DataDimensionValueLogicConfig } from "./dimension.data.value.logic";
import { DataDimensionValueLogic } from "./dimension.data.value.logic";
import type { DataDimensionValueNoneConfig } from "./dimension.data.value.none";
import { DataDimensionValueNone } from "./dimension.data.value.none";
import type { DataDimensionValueRequestParameterConfig } from "./dimension.data.value.requestParameter";
import { DataDimensionValueRequestParameter } from "./dimension.data.value.requestParameter";

export type DataDimensionValueConfig =
    | DataDimensionValueNoneConfig
    | DataDimensionValueJsonConfig
    | DataDimensionValueRequestParameterConfig
    | DataDimensionValueLogicConfig;

export function getDataDimensionValueHandler(
    id: string,
    config: DataDimensionValueConfig,
): DataDimensionValue {
    switch (config.type) {
        case DataDimensionValueType.NONE:
            return new DataDimensionValueNone(id, config);
        case DataDimensionValueType.JSON:
            return new DataDimensionValueJson(id, config);
        case DataDimensionValueType.REQUEST_PARAMETER:
            return new DataDimensionValueRequestParameter(id, config);
        case DataDimensionValueType.LOGIC:
            return new DataDimensionValueLogic(id, config);
        default:
            throw new Error(`Unknown value type ${(config as any).type}`);
    }
}
